import React from "react";
import PropTypes from "prop-types";
import Column from "./Column";
import {Number} from "@morningtrain/react-displays";

function NumberColumn(props) {
    return <Column {...props} />;
}

NumberColumn.defaultProps = {
    ...Column.defaultProps,
    display: Number
};

NumberColumn.propTypes = {
    ...Column.propTypes,
};

export default NumberColumn;
